import React from 'react';
import { useStyles } from '@archipro-design/aria';
import * as S from './OptionPicker.mobile.style';
import type ProductSize from '../../type/product-size';
import type { BasePickerProps } from './OptionPicker.mobile';
import { useVariantOptionState } from '../../context/VariantOptionContext';
import { useVariantDecision } from '../../hook/use-variant-decision';
import type { ItemType } from './OptionRadioGroup.mobile';
import OptionRadioGroup from './OptionRadioGroup.mobile';
import OptionHeader from './OptionHeader.mobile';
import { SizeContent, SizeRadioGroup } from './SizePicker.mobile.style';

type SizePickerProps = BasePickerProps & {
    data: {
        sizes: ProductSize[];
    };
};

const emptyOption = {
    ID: 0,
    label: 'Not Applicable',
};

const SizePicker = ({
    data: { sizes, variants },
    isGeneric,
    hasManyOptions = true,
}: SizePickerProps) => {
    const { decision } = useVariantOptionState();
    const { pickSize } = useVariantDecision(variants);
    const [expanded, setExpanded] = React.useState(false);
    const { css } = useStyles({ expanded });

    const selectedOptionID = decision.size ?? 0;

    const items: ItemType[] = sizes.map((opt) => ({
        ID: opt.ID,
        label: (
            <div>
                <span className={css(SizeContent)}>{opt.FullTitle}</span>
            </div>
        ),
    }));

    const option =
        items.find((opt) => opt.ID === selectedOptionID) ?? emptyOption;

    if (!isGeneric) {
        items.unshift(emptyOption);
    }

    const toggleExpanded = () => {
        if (hasManyOptions) {
            setExpanded((e) => !e);
        }
    };
    return (
        <div className={css(S.OptionPicker, SizeRadioGroup)}>
            <OptionHeader
                title={'Size'}
                subTitle={<div className={css(S.SubTitle)}>{option.label}</div>}
                expanded={expanded}
                onClick={toggleExpanded}
                hasManyOptions={hasManyOptions}
            />
            <OptionRadioGroup
                onSelect={(sizeID) => pickSize(sizeID)}
                visible={expanded}
                selectedID={selectedOptionID}
                items={items}
            />
        </div>
    );
};

export default SizePicker;
